import AsyncStatus from 'mini-common-schema/lib/schema/AsyncStatus';
import getCurrentSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import { orchestrator } from 'satcheljs';
import { removeTableView } from 'mini-mail-list-actions';
import { resetMailSearchStore } from '../actions/publicActions';
import { setAsyncStatus } from '../actions/privateActions';
import { setSelectedTableViewId } from 'mini-mail-list-actions/lib/actions/tables/setSelectedTableViewId';
import { TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';

export const resetMailSearchStoreOrchestrator = orchestrator(resetMailSearchStore, () => {
    // reset mail results table view
    // On SearchResults exit, we no longer need the mail results tableView once we hit back button. Hence removing.
    const currentSelectedTableView = getCurrentSelectedTableView();
    if (currentSelectedTableView?.tableQuery?.type === TableQueryType.Search) {
        setSelectedTableViewId(null);
        currentSelectedTableView && removeTableView(currentSelectedTableView);
    }
    setAsyncStatus(AsyncStatus.Idle);
});
